import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardService, DashboardLoanCategory } from '../services/dashboard/dashboard.service';
import { LoanFacts, DashboardData } from '../models/index';
import LoanDashboardCategory = LoanFacts.LoanDashboardCategoryEnum;

@Component({
  selector: 'ld-my-loans-list',
  templateUrl: './my-loans-list.template.html',
  styleUrls: [ './my-loans-list.style.scss' ]
})
export class MyLoansListComponent implements OnInit {

  @Input() public isOnSidePanel = false;
  @Output() public showSidePanel = new EventEmitter();

  public loanCategories: DashboardLoanCategory[];

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.dashboardService.getCategorizedLoanFacts(false).subscribe(loanFactResponse => {
      this.loanCategories = loanFactResponse.filter(category => category.loans.length > 0);
    }, err => {
      console.error(err);
    });
  }
}
